import React from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const TermsOfService = () => {
  // Scroll to top when component mounts
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-grow container mx-auto px-4 py-8 max-w-4xl">
        <div className="mb-6">
          <Button
            variant="ghost"
            asChild
            className="text-legal-blue hover:text-legal-navy">
            <Link to="/" className="flex items-center gap-2">
              <ArrowLeft size={16} />
              Volver al inicio
            </Link>
          </Button>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-6 text-legal-navy">
          Términos de Servicio y Política de Privacidad
        </h1>
        <p className="text-sm text-gray-500 mb-6">
          Última actualización: {new Date().toLocaleDateString("es-CO")}
        </p>

        <div className="prose max-w-none prose-headings:text-legal-navy prose-a:text-legal-blue">
          <p className="mb-6">
            MiAsistenteLegalIA ("nosotros", "nuestro" o "nuestra") opera bajo el
            marco legal de la Ley 1581 de 2012 y sus decretos reglamentarios,
            que regulan el tratamiento de datos personales en Colombia.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Aceptación de los Términos
          </h2>
          <p className="mb-6">
            Al acceder o usar nuestro Servicio, usted acepta estar sujeto a
            estos Términos y autoriza el tratamiento de sus datos personales
            conforme a la Ley 1581 de 2012.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Tratamiento de Datos Personales
          </h2>
          <p className="mb-6">
            Como Responsable del Tratamiento de datos personales, nos
            comprometemos a:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>
              Obtener autorización previa, expresa e informada para el
              tratamiento de datos
            </li>
            <li>Informar claramente la finalidad del tratamiento</li>
            <li>
              Garantizar el derecho de acceso, corrección, actualización y
              supresión de datos
            </li>
            <li>Mantener la confidencialidad y seguridad de la información</li>
            <li>Respetar los derechos de los titulares de datos</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Derechos de los Titulares
          </h2>
          <p className="mb-6">
            De acuerdo con la Ley 1581 de 2012, usted tiene derecho a:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>Conocer, actualizar y rectificar sus datos personales</li>
            <li>Solicitar prueba de la autorización otorgada</li>
            <li>Ser informado sobre el uso que se ha dado a sus datos</li>
            <li>
              Presentar quejas ante la Superintendencia de Industria y Comercio
            </li>
            <li>
              Revocar la autorización y/o solicitar la supresión de sus datos
            </li>
            <li>Acceder en forma gratuita a sus datos personales</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Finalidades del Tratamiento
          </h2>
          <p className="mb-6">Sus datos personales serán tratados para:</p>
          <ul className="list-disc pl-6 mb-6">
            <li>Prestación de servicios legales y asesoría jurídica</li>
            <li>Gestión de suscripciones y facturación</li>
            <li>Comunicación de novedades y actualizaciones del servicio</li>
            <li>Mejora continua de nuestros servicios</li>
            <li>Cumplimiento de obligaciones legales</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Medidas de Seguridad
          </h2>
          <p className="mb-6">
            Implementamos medidas técnicas, humanas y administrativas para
            proteger sus datos personales, incluyendo:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>Encriptación de datos sensibles</li>
            <li>Control de acceso y autenticación</li>
            <li>Procedimientos de respaldo y recuperación</li>
            <li>Capacitación del personal en protección de datos</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Transferencia de Datos
          </h2>
          <p className="mb-6">
            Sus datos personales podrán ser transferidos a terceros cuando sea
            necesario para:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>Cumplir con obligaciones legales</li>
            <li>Prestar servicios complementarios</li>
            <li>Realizar procesamiento de pagos</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Procedimiento para Ejercer Derechos
          </h2>
          <p className="mb-6">
            Para ejercer sus derechos como titular de datos, puede contactarnos
            a través de:
          </p>
          <ul className="list-disc pl-6 mb-6">
            <li>Correo electrónico: notificaciones@miasistentelegalia.com</li>
            <li>Dirección: Medellin,Colombia</li>
          </ul>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Cambios en la Política
          </h2>
          <p className="mb-6">
            Nos reservamos el derecho de modificar esta política en cualquier
            momento. Los cambios serán notificados a través de nuestro sitio web
            y, cuando sea necesario, mediante comunicación directa.
          </p>

          <h2 className="text-2xl font-semibold mt-8 mb-4">
            Autoridad de Control
          </h2>
          <p className="mb-6">
            La Superintendencia de Industria y Comercio es la autoridad
            competente para atender quejas y reclamos sobre el tratamiento de
            datos personales en Colombia.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default TermsOfService;
